import { combineReducers } from 'redux';

import loading from 'modules/global/reducers/generic.loading';
import genericSelectSlice from 'modules/global/reducers/generic.selectSlice';
import loadingArray from 'modules/global/reducers/loadingArraySlice';
import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import * as types from 'modules/screensaver/actionTypes';
import { SCREENSAVER_DASHBOARD } from 'modules/screensaver/constants';

import details from './details';
import filters from './filters';

/**
 * @typedef {{
 *   dashboard: {
 *     data: import('modules/global/reducers/simpleSearchReducer').SimpleSearchReducer,
 *     filters: import('./filters').ScreensaverFiltersReducer,
 *     loading: {
 *       clone: boolean,
 *       delete: import("modules/global/reducers/loadingArraySlice").LoadingArraySlice,
 *     }
 *   },
 *   details : {
 *     loading: {
 *       creating: boolean,
 *       updating: boolean,
 *     },
 *     ready: boolean,
 *   },
 *   selects: import("modules/global/reducers/generic.selectSlice").GenericSelectsReducer,
 * }} ScreensaverUIReducer
 */

export const dashboardMatcher = ({ meta }) => meta?.target === SCREENSAVER_DASHBOARD;

export const data = createSearchReducers(types.FETCH_SCREENSAVERS, {
  global: { matcher: dashboardMatcher, paginationSlice: true },
});

export const selectId = entity => entity?.screensaverId ?? entity?.id ?? entity;

export const loadingReducer = combineReducers({
  clone: loading(types.CLONE_SCREENSAVER, { global: { matcher: dashboardMatcher } }),
  delete: loadingArray(types.DELETE_SCREENSAVER, { global: { matcher: dashboardMatcher, selectId } }),
});

export const selectsReducer = genericSelectSlice(types.FETCH_AVAILABLE_SCREENSAVERS);

export default combineReducers({
  dashboard: combineReducers({
    data,
    filters,
    loading: loadingReducer,
  }),
  details,
  selects: selectsReducer,
});
